var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 225,
    viewBox: "0 0 210 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.5 68.0207C113.666 66.7703 116.334 66.7703 118.5 68.0207L141.811 81.4793C143.977 82.7297 145.311 85.0406 145.311 87.5415V114.459C145.311 116.959 143.977 119.27 141.811 120.521L118.5 133.979C116.334 135.23 113.666 135.23 111.5 133.979L88.1891 120.521C86.0233 119.27 84.6891 116.959 84.6891 114.459V87.5415C84.6891 85.0406 86.0233 82.7297 88.1891 81.4793L111.5 68.0207Z",
    fill: "url(#paint0_linear_5784_10050)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192 68.8868C193.856 67.815 196.144 67.815 198 68.8868L221.311 82.3453C223.167 83.4171 224.311 85.3979 224.311 87.5415V114.459C224.311 116.602 223.167 118.583 221.311 119.655L198 133.113C196.144 134.185 193.856 134.185 192 133.113L168.689 119.655C166.833 118.583 165.689 116.602 165.689 114.459V87.5415C165.689 85.3979 166.833 83.4171 168.689 82.3453L192 68.8868Z",
    stroke: "#BECFEF",
    strokeOpacity: 0.2,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.5 134.021C153.666 132.77 156.334 132.77 158.5 134.021L181.811 147.479C183.977 148.73 185.311 151.041 185.311 153.541V180.459C185.311 182.959 183.977 185.27 181.811 186.521L158.5 199.979C156.334 201.23 153.666 201.23 151.5 199.979L128.189 186.521C126.023 185.27 124.689 182.959 124.689 180.459V153.541C124.689 151.041 126.023 148.73 128.189 147.479L151.5 134.021Z",
    fill: "url(#paint1_linear_5784_10050)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.5 200.021C113.666 198.77 116.334 198.77 118.5 200.021L141.811 213.479C143.977 214.73 145.311 217.041 145.311 219.541V246.459C145.311 248.959 143.977 251.27 141.811 252.521L118.5 265.979C116.334 267.23 113.666 267.23 111.5 265.979L88.1891 252.521C86.0233 251.27 84.6891 248.959 84.6891 246.459V219.541C84.6891 217.041 86.0233 214.73 88.1891 213.479L111.5 200.021Z",
    fill: "url(#paint2_linear_5784_10050)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 200.021C33.6658 198.77 36.3342 198.77 38.5 200.021L61.8109 213.479C63.9767 214.73 65.3109 217.041 65.3109 219.541V246.459C65.3109 248.959 63.9767 251.27 61.8109 252.521L38.5 265.979C36.3342 267.23 33.6658 267.23 31.5 265.979L8.18911 252.521C6.0233 251.27 4.68911 248.959 4.68911 246.459V219.541C4.68911 217.041 6.0233 214.73 8.18911 213.479L31.5 200.021Z",
    fill: "url(#paint3_linear_5784_10050)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M233.5 134.021C235.666 132.77 238.334 132.77 240.5 134.021L263.811 147.479C265.977 148.73 267.311 151.041 267.311 153.541V180.459C267.311 182.959 265.977 185.27 263.811 186.521L240.5 199.979C238.334 201.23 235.666 201.23 233.5 199.979L210.189 186.521C208.023 185.27 206.689 182.959 206.689 180.459V153.541C206.689 151.041 208.023 148.73 210.189 147.479L233.5 134.021Z",
    fill: "url(#paint4_linear_5784_10050)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M151.5 2.02073C153.666 0.770296 156.334 0.770296 158.5 2.02073L181.811 15.4793C183.977 16.7297 185.311 19.0406 185.311 21.5415V48.4585C185.311 50.9594 183.977 53.2703 181.811 54.5207L158.5 67.9793C156.334 69.2297 153.666 69.2297 151.5 67.9793L128.189 54.5207C126.023 53.2703 124.689 50.9594 124.689 48.4585V21.5415C124.689 19.0406 126.023 16.7297 128.189 15.4793L151.5 2.02073Z",
    fill: "url(#paint5_linear_5784_10050)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M192 200.887C193.856 199.815 196.144 199.815 198 200.887L221.311 214.345C223.167 215.417 224.311 217.398 224.311 219.541V246.459C224.311 248.602 223.167 250.583 221.311 251.655L198 265.113C196.144 266.185 193.856 266.185 192 265.113L168.689 251.655C166.833 250.583 165.689 248.602 165.689 246.459V219.541C165.689 217.398 166.833 215.417 168.689 214.345L192 200.887Z",
    stroke: "#BECFEF",
    strokeOpacity: 0.2,
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88 189H52C47.029 189 43 184.971 43 180V156C43 151.029 47.029 147 52 147H88C92.971 147 97 151.029 97 156V180C97 184.971 92.971 189 88 189Z",
    fill: "url(#paint6_linear_5784_10050)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M58 147C58 140.373 63.373 135 70 135C76.627 135 82 140.373 82 147H88C88 137.058 79.942 129 70 129C60.058 129 52 137.058 52 147H58Z",
    fill: "#4671F6"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M70 162C66.685 162 64 164.685 64 168C64 171.315 66.685 174 70 174C73.315 174 76 171.315 76 168C76 164.685 73.315 162 70 162Z",
    fill: "#4671F6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5784_10050",
    x1: 115,
    y1: 66,
    x2: 115,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5784_10050",
    x1: 155,
    y1: 132,
    x2: 155,
    y2: 202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5784_10050",
    x1: 115,
    y1: 198,
    x2: 115,
    y2: 268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5784_10050",
    x1: 35,
    y1: 198,
    x2: 35,
    y2: 268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5784_10050",
    x1: 237,
    y1: 132,
    x2: 237,
    y2: 202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5784_10050",
    x1: 155,
    y1: 0,
    x2: 155,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5784_10050",
    x1: 97,
    y1: 189,
    x2: 80.35,
    y2: 174.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6EAFB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIll);
export default __webpack_public_path__ + "static/media/ill.38679727f2ebbac3db3815cfb1616ca4.svg";
export { ForwardRef as ReactComponent };